export default __webpack_public_path__ + "static/media/html.d873b180.png";